import { render, staticRenderFns } from "./RightChart2.vue?vue&type=template&id=1dcb6172&scoped=true&"
import script from "./RightChart2.vue?vue&type=script&lang=js&"
export * from "./RightChart2.vue?vue&type=script&lang=js&"
import style0 from "./RightChart2.vue?vue&type=style&index=0&id=1dcb6172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcb6172",
  null
  
)

export default component.exports